export default __webpack_public_path__ + "static/media/import-white.e4635247.svg";